import { Helmet } from 'react-helmet-async';
import { useState, useCallback, useEffect } from 'react';
import { io } from 'socket.io-client';

// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Typography,
  IconButton,
  TableContainer,
  CircularProgress,
  Pagination,
  FormControl,
  InputLabel,
  Select,
  Grid
} from '@mui/material';

// cambios realizados para la actividad

import CustomModal from '../components/modal/CustomModal';

import FormArticle from '../components/forms/inventory/article'
import { formatoFecha, formatoFechaAmFm, formatoFechaTable } from '../context/DateInstance';


import Iconify from '../components/iconify';
// sections
// mock


import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// hooks
import { useAxios } from '../context/AxiosHookContext';
import { useAuth } from '../context/AuthContext';
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: '', label: 'Periodo/Fecha', alignRight: false },
  { id: '', label: 'Código Inst.', alignRight: false },
  { id: '', label: 'Descripción', alignRight: false },
  { id: '', label: 'Medida', alignRight: false },
  { id: '', label: 'Costo Unit.', alignRight: false },
  { id: '', label: 'Costo Actual', alignRight: false },
  { id: '', label: 'Existencia.', alignRight: false },
  { id: '', label: 'Categoría', alignRight: false },
  { id: '' },
];




// ----------------------------------------------------------------------
export default function InventoryAdmin() {

  const { currentUser } = useAuth();
  const [openModalActivities, setOpenModalActivities] = useState(false);
  const [filterName, setFilterName] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1)
  const [loading, setLoading] = useState(false)
  const [articlesList, setArticlesList] = useState([])
  const [valuesToEdit, setValuesToEdit] = useState({})
  const [selectedOrderType, setSectedOrderType] = useState()
  const [open, setOpen] = useState(null);
  const [seletedArticle, setseletedArticle] = useState(true);


  const TICKETS_API = `/inventory/articles?&page=${page}&size=${10}&${filterName ? `&description=${filterName}` : ''}&${selectedOrderType === 1 ? 'units=1' : selectedOrderType === -1 ? 'units=-1' : ''}`
  const axios = useAxios();


  const handleOpenMenu = (event, values) => {
    setOpen(event.currentTarget);
    setValuesToEdit(values)
  };

  const handleDoubleClick = (values) => {
    setValuesToEdit(values)
    setOpenModalActivities(true)
  }


  const handleCloseMenu = () => {
    setOpen(null);
  };


  const getTickets = useCallback(async () => {
    try {
      setArticlesList([])
      setLoading(true);
      const { data } = await axios.get(TICKETS_API);
      setArticlesList(data?.data?.list || []);
      setTotalPages(data?.data?.total_pages || 1)


    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [axios, TICKETS_API, setArticlesList, setLoading, filterName, selectedOrderType]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };


  useEffect(() => {
    getTickets();
  }, [getTickets, page, selectedOrderType, filterName])


  return (
    <>

      <Helmet>
        <title>Manejo de Inventario | {process.env.REACT_APP_APP_NAME}</title>
      </Helmet>

      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Typography variant="h4" gutterBottom>
          Listado de items
        </Typography>
        <Button onClick={() => { setOpenModalActivities(true); setValuesToEdit({}) }} variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
          Agregar item
        </Button>
      </Stack>

      <Card>

        <Grid container alignItems={"center"}>

          <UserListToolbar filterName={filterName} onFilterName={(e) => setFilterName(e.target.value)} />

          <FormControl sx={{ width: 250, m: 2 }}>
                <InputLabel
                  id="role-label"
                  sx={{ marginTop: '-0.4rem' }} // Ajusta el valor según sea necesario
                >
                  Existencia por:
                </InputLabel>
                <Select
                  labelId="role-label"
                  id="role"
                  value={selectedOrderType}
                  onChange={(e) => { setSectedOrderType(e.target.value) }}
                  size="small"
                  label="Existencia por:"
                >
                  <MenuItem value={1}>De menor a mayor</MenuItem>
                  <MenuItem value={-1}>De mayor a menor</MenuItem>
                </Select>
              </FormControl>


        </Grid>

        <TableContainer sx={{ minWidth: 800 }}>
          <Table>
            <UserListHead
              headLabel={TABLE_HEAD}
            />
            <TableBody>
              {articlesList.length > 0 && articlesList.map((row) =>

              (
                <TableRow hover key={row._id} tabIndex={-1} role="checkbox" sx={{ cursor: "pointer" }} onDoubleClick={() => handleDoubleClick(row)}>

                  <TableCell component="th" scope="row" padding="normal">
                    {formatoFechaTable(row.period)}
                  </TableCell>

                  <TableCell component="th" scope="row" padding="normal">
                    {row?._id}
                  </TableCell>

                  <TableCell align="left">
                    {row.description}
                  </TableCell>


                  <TableCell align="left">
                    {row.distrUnit}
                  </TableCell>

                  <TableCell align="left">
                    {row.unitCost}
                  </TableCell>

                  <TableCell align="left">
                    {row.currentValue}
                  </TableCell>

                  <TableCell align="left">
                    {row.units}
                  </TableCell>


                  <TableCell align="left">
                    {row.category || "N/A"}
                  </TableCell>
                  
                  <TableCell align="right">
                    <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, row)}>
                      <Iconify icon={'eva:more-vertical-fill'} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

            {
              loading === true &&
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
                    <Paper
                      sx={{
                        textAlign: 'center',
                      }}
                    >

                      <CircularProgress size={"30px"} sx={{ color: "#aa9e97", marginRight: "auto", marginLeft: "auto" }} />

                    </Paper>
                  </TableCell>
                </TableRow>
              </TableBody>
            }

            {
              (articlesList.length === 0 && loading === false) &&
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
                    <Paper
                      sx={{
                        textAlign: 'center',
                      }}
                    >

                      <Typography variant="h6" paragraph>
                        Sin resultados
                      </Typography>

                      <Typography variant="body2">
                        No se encontraron resultados
                        <br /> Intente con otra búsqueda.
                      </Typography>
                    </Paper>
                  </TableCell>
                </TableRow>
              </TableBody>
            }

          </Table>
        </TableContainer>

        <Pagination
          count={totalPages}
          page={page}
          onChange={handleChangePage}

          sx={{ float: "right", margin: 2, color: "#ffe7d9" }}
        />

      </Card>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 160,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={() => { setOpenModalActivities(true); setOpen(null) }} >
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Editar
        </MenuItem>

      </Popover>


      <CustomModal
        open={openModalActivities}
        modalStyle={{ width: "80%", minWidth: 440, maxHeight: "70vh", overflowX: "auto" }}
        title={"Formulario de items"}
      >
        <FormArticle
          onClose={() => setOpenModalActivities(false)}
          getValues={() => {
            getTickets();
            setOpenModalActivities(false);
            setValuesToEdit({});
            setOpen(null);
          }}
          valuesToEdit={valuesToEdit}
        />
      </CustomModal>
    </>
  );
}
